import { render, staticRenderFns } from "./DenunciationsPg.vue?vue&type=template&id=04567e9f&scoped=true&"
import script from "./DenunciationsPg.vue?vue&type=script&lang=js&"
export * from "./DenunciationsPg.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationsPg.vue?vue&type=style&index=0&id=04567e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04567e9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
